import { Component } from '@angular/core';
import {WaitsService} from './waits.service';
import {EJobState} from '../jobs/job-state.enum';
import {EJobType} from '../jobs/job-type.enum';

@Component({
  selector: 'waits',
  templateUrl: 'waits.component.html',
  styleUrls: ['waits.component.scss']
})
export class WaitsComponent {
  public jobStates = EJobState;
  public jobType = EJobType.Wait;
  public selectedTab: number = 0;
  constructor() {
  }

  async ngOnInit() {
  }
}
